import { http } from '@/environment/environment';

class FeedbackService
{
    getFeedbackList(userId: string, gameId: string): Promise<any> {
        return http.get(`games/${gameId}/feedbacks?userId=${userId}`);
    }
}

export default new FeedbackService();